import CryptoJS from 'crypto-js';
import { ALCATRAZ_CRYPTO_KEY, ALCATRAZ_INITIAL_TOKEN } from './env';

export function setEncryptedData(data, storage) {
  const encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    ALCATRAZ_CRYPTO_KEY,
  ).toString();

  localStorage.setItem(storage, encryptedData);
}

export function getEncryptedData(key) {
  const stored = localStorage.getItem(key);
  if (!stored) return null;

  if (stored.startsWith(ALCATRAZ_INITIAL_TOKEN)) {
    try {
      const decrypted = CryptoJS.AES.decrypt(stored, ALCATRAZ_CRYPTO_KEY);
      const utf8 = decrypted.toString(CryptoJS.enc.Utf8);

      if (!utf8) throw new Error('Empty decrypted string');

      return tryParseJSON(utf8);
    } catch (error) {
      console.error('Decryption error:', error);
      return tryParseJSON(stored);
    }
  }

  return tryParseJSON(stored);
}

function tryParseJSON(value) {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}

const encryptIfNeeded = (value, storage) => {
  const logout = window?.location?.pathname === '/logout' || window?.location?.pathname === '/';
  if (!value?.startsWith(ALCATRAZ_INITIAL_TOKEN) && !logout) {
    setEncryptedData(value, storage);

    // refresh page after last param update
    if (storage === 'deviceId') {
      window.location.reload();
    }
  }
};

export function decryptAllData() {
  const deviceId = getEncryptedData('deviceId');
  localStorage.setItem('deviceId', deviceId);
  const state = getEncryptedData('state');
  localStorage.setItem('state', state);
  const renewEntitlements = getEncryptedData('renewEntitlements');
  localStorage.setItem(
    'renewEntitlements',
    typeof renewEntitlements === 'string'
      ? renewEntitlements
      : JSON.stringify(renewEntitlements),
  );
  const frToken = getEncryptedData('frToken');
  localStorage.setItem('frToken', frToken);
  const modalGranHermanoShownList = getEncryptedData('modalGranHermanoShownList');
  localStorage.setItem('modalGranHermanoShownList', modalGranHermanoShownList);
}

export function encryptAllData() {
  const profiles = localStorage.getItem('profiles');
  encryptIfNeeded(profiles, 'profiles');
  const profile = localStorage.getItem('profile');
  encryptIfNeeded(profile, 'profile');
  const state = localStorage.getItem('state');
  encryptIfNeeded(state, 'state');
  const renewEntitlements = localStorage.getItem('renewEntitlements');
  encryptIfNeeded(renewEntitlements, 'renewEntitlements');
  const frToken = localStorage.getItem('frToken');
  encryptIfNeeded(frToken, 'frToken');
  const deviceId = localStorage.getItem('deviceId');
  encryptIfNeeded(deviceId, 'deviceId');
}

// for Feature Flag
export const decryptIfNeeded = (storage) => {
  const value = localStorage.getItem(storage);
  const logout = window?.location?.pathname === '/logout';
  const allowOnLogout = ['deviceId', 'modalGranHermanoShownList', 'notificationsPermission'];

  const shouldDecrypt = typeof value !== 'object'
    && value?.startsWith(ALCATRAZ_INITIAL_TOKEN)
    && (!logout || allowOnLogout.includes(storage));

  if (shouldDecrypt) {
    const decryptValue = getEncryptedData(storage, true);
    const valueToStore = typeof decryptValue === 'object' ? JSON.stringify(decryptValue) : decryptValue;
    localStorage.setItem(storage, valueToStore);
  }
};

// for Feature Flag
export function decryptAllDataifNeeded() {
  decryptIfNeeded('profile');
  decryptIfNeeded('profiles');
  decryptIfNeeded('state');
  decryptIfNeeded('renewEntitlements');
  decryptIfNeeded('frToken');
  decryptIfNeeded('deviceId');
  decryptIfNeeded('notificationsPermission');
  decryptIfNeeded('modalGranHermanoShownList');
}
